import React from 'react';
import Slider from 'react-slick'; 

function HeroSlider() {
  
  // --- GÜNCELLENDİ --- 12 Elemanlı Resim Listesi (a7, a7, a7...)
  const slideImages = [
    '/a1.png', 
    '/a7.png', // BOŞ YAZI
    '/a2.png', 
    '/a7.png', // BOŞ YAZI
    '/a3.png', 
    '/a7.png', // BOŞ YAZI
    '/a4.png',
    '/a7.png', // BOŞ YAZI
    '/a5.png',
    '/a7.png', // BOŞ YAZI
    '/a6.png', 
    '/a7.png'  // BOŞ YAZI
  ];

  // --- GÜNCELLENDİ --- 12 Elemanlı İçerik Listesi
  const sliderContent = [
    // 1. Resim (a1.png)
    { title: "Aras Asaf İnşaat", text: "Kaliteli Yapılar, Güvenli Gelecek", location: "Manisa - Akhisar" },
    // 2. Resim (a7.png) - BOŞ
    { title: "", text: "", location: "" }, 
    // 3. Resim (a2.png)
    { title: "Modern Konut Projeleri", text: "Hayalinizdeki Yaşam Alanlarını Tasarlıyoruz", location: "Akhisar Şubesi" },
    // 4. Resim (a7.png) - BOŞ
    { title: "", text: "", location: "" },
    // 5. Resim (a3.png)
    { title: "İnşaat Sahası Yönetimi", text: "Projeniz En Hızlı Şekilde Yükseliyor", location: "Merkez Şantiye" },
    // 6. Resim (a7.png) - BOŞ
    { title: "", text: "", location: "" },
    // 7. Resim (a4.png)
    { title: "Altyapı ve Taahhüt", text: "Güven ve Tecrübe ile Büyük Projeler", location: "" },
    // 8. Resim (a7.png) - BOŞ
    { title: "", text: "", location: "" },
    // 9. Resim (a5.png)
    { title: "Geleceğe Değer", text: "Yatırıma Uygun Ticari Yapılar", location: "" },
    // 10. Resim (a7.png) - BOŞ
    { title: "", text: "", location: "" },
    // 11. Resim (a6.png)
    { title: "Anahtar Teslim Çözümler", text: "Sektör Lideri Yüksek Standartlarda", location: "" },
    // 12. Resim (a7.png) - BOŞ
    { title: "", text: "", location: "" }, 
  ];

  const settings = {
    dots: true,       
    infinite: true,   
    speed: 400,       
    slidesToShow: 1,  
    slidesToScroll: 1, 
    autoplay: true,     
    autoplaySpeed: 3000, 
    fade: true,         
    cssEase: 'linear',
    arrows: false,      
  };

  return (
    <section className="hero-slider" id="anasayfa">
      <Slider {...settings}>
        
        {slideImages.map((imagePath, index) => (
          <div className="slider-item" key={index}>
            <div 
              className="slider-image" 
              // Resim yolunu dinamik olarak 'public' klasöründen çekiyoruz
              style={{ 
                // Resmi 'cover' ile ekranı dolduracak şekilde ayarla
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('${imagePath}')` 
              }}
            >
              <div className="hero-content">
                {/* 12 içerikten herhangi birine atıfta bulunabiliriz */}
                {index < sliderContent.length && (
                  <>
                    <h1>{sliderContent[index].title}</h1>
                    <p>{sliderContent[index].text}</p>
                    <div className="hero-location">{sliderContent[index].location}</div>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
        

      </Slider>
    </section>
  );
}

export default HeroSlider;